import script from "./Unlogin.vue?vue&type=script&lang=ts&setup=true"
export * from "./Unlogin.vue?vue&type=script&lang=ts&setup=true"

import "./Unlogin.vue?vue&type=style&index=0&id=15ae8d0e&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15ae8d0e"]])

export default __exports__